/**
 * 正则表达式模块，常用的表达式集合
 *
 * @module regex
 */

/**
 * url表达式
 * @member URL
 */
export const URL = /^(http|https):\/\/[\w.:\-@]*/;

/**
 * email表达式
 * @member EMAIL
 */
export const EMAIL = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

/**
 * 身份证号码表达式
 * @member ID
 */
export const ID_NUM = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;

/**
 * 手机号码表达式
 * @member MOBILE_PHONE
 */
export const MOBILE_PHONE = /^(0|86|17951)?(1[\d]{10})$/;

// 新能源车牌
export const XREG = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
// 旧车牌
export const CREG = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;

/**
 * 检测字符串是否url
 * @param {string} str 需要检测的字符串
 * @returns {boolean}
 */
export function isUrl(str) {
  return URL.test(str);
}

/**
 * 检测字符串是否邮箱
 * @param {string} str 需要检测的字符串
 * @returns {boolean}
 */
export function isEmail(str) {
  return EMAIL.test(str);
}

/**
 * 检测字符串是否身份证号码
 * @param {string} str 需要检测的字符串
 * @returns {boolean}
 */
export function isIdNum(str) {
  return ID_NUM.test(str);
}

/**
 * 检测字符串是否手机号码
 * @param {string} str 需要检测的字符串
 * @returns {boolean}
 */
export function isMobilePhone(str) {
  return MOBILE_PHONE.test(str);
}

/**
 * 是否车牌号
 */
export function isCarNo(value) {
  if (value.length === 7) {
    return CREG.test(value);
  } else if (value.length === 8) {
    return XREG.test(value);
  } else {
    return false;
  }
}

export default {
  URL,
  EMAIL,
  ID_NUM,
  MOBILE_PHONE,
  isUrl,
  isEmail,
  isIdNum,
  isMobilePhone,
  isCarNo
};
